/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiInsurance
 */
export interface ApiInsurance {
    /**
     * 
     * @type {string}
     * @memberof ApiInsurance
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ApiInsurance
     */
    id: number;
}

export function ApiInsuranceFromJSON(json: any): ApiInsurance {
    return ApiInsuranceFromJSONTyped(json, false);
}

export function ApiInsuranceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiInsurance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
    };
}

export function ApiInsuranceToJSON(value?: ApiInsurance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
    };
}

